import {Component} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {FormWrapperComponent} from '../../components/form-wrapper/form-wrapper.component';

@Component({
  selector: 'app-no-access',
  imports: [FormWrapperComponent, TranslatePipe],
  templateUrl: './no-access.component.html',
  styleUrl: './no-access.component.scss',
})
export class NoAccessComponent {

}
